import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container p-3 p-md-4" }
const _hoisted_2 = {
  class: "card shadow-sm",
  style: {"max-width":"480px"}
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "mb-3" }, "Company Settings", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "form-label fw-medium" }, "Default Check-Call Interval (minutes)", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.minutes) = $event)),
            min: "1",
            step: "1"
          }, null, 512), [
            [_vModelText, _ctx.minutes]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "form-text" }, " Used by any job that doesn't set its own check-call interval override. ", -1))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          disabled: _ctx.isSaving,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createTextVNode(" Save ", -1))
        ], 8, _hoisted_5)
      ])
    ])
  ]))
}